import { FlakinessReport } from '@flakiness/flakiness-report';
import { WireTypes } from '@flakiness/server/common/wireTypes.js';
import { LitElement, css, html, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { forgeUtils } from '../forgeUtils.js';
import { linkStyles } from './cssstyles.js';

@customElement('a-location')
class ALocation extends LitElement {
  @property({ type: String }) project?: WireTypes.Project;
  @property({ type: String }) location?: FlakinessReport.Location;
  @property({ type: String }) commitId?: FlakinessReport.CommitId;

  render() {
    if (!this.location || !this.commitId)
      return nothing;
    const filepath = this.location.file;
    return html`
      <a-ext  href=${forgeUtils.hasSourceUrl(this.project) ? forgeUtils.fileUrl(this.project, this.commitId, this.location.file, this.location.line) : nothing}>
        <h-box class=container title=${filepath + ':' + this.location.line}>
          <span class=path>${filepath}</span>
          <span class=linenumber>:${this.location.line}</span>
        </h-box>
      </a-ext>
    `;
  }

  static styles = [linkStyles, css`
    :host {
      display: flex;
      overflow: hidden;
      white-space: nowrap;
    }
    a-ext {
      display: flex;
      overflow: hidden;
    }
    .container {
      gap: 0;

      .path {
        min-width: 1em;
        overflow: hidden;
        flex: auto;
        direction: rtl;
        text-overflow: ellipsis;
      }

      .linenumber {
        flex: none;
      }
    }
  `];
}
